export const FT_START_TEST = 'FT_START_TEST';
export const FT_STOP_TEST = 'FT_STOP_TEST';
export const FT_SET_TEST_CONTENT = 'FT_SET_TEST_CONTENT';
export const FT_SELECT_SECTION = 'FT_SELECT_SECTION';
export const FT_SELECT_QUESTION = 'FT_SELECT_QUESTION';
export const FT_ANSWER = 'FT_ANSWER';
export const FT_NEXT_QUESTION = 'FT_NEXT_QUESTION';
export const FT_PREV_QUESTION = 'FT_PREV_QUESTION';
export const FT_TIME_OUT = 'FT_TIME_OUT';
